export enum NodeType {
    Form = 'Form',
    TeamReview = 'TeamReview',
    AutomatedAction = 'AutomatedAction',
    Consultation = 'Consultation',
}
